import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import useStyles from './styles';

export interface ICustomSwitch {
  label: string;
  name: string;
  initialState: boolean;
  handleSelectColumn: (column: any) => void;
}

const OysterSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 32,
      height: 20,
      padding: 0,
      display: 'flex',
      marginLeft: 10,
    },
    switchBase: {
      padding: 2,
      color: theme.oysterTheme.cotton,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.oysterTheme.dolphin,
        borderColor: theme.oysterTheme.dolphin,
      },
      '&$checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.oysterTheme.oyster,
          borderColor: theme.oysterTheme.oyster,
        },
      },
    },
    thumb: {
      width: 16,
      height: 16,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.oysterTheme.shark}`,
      borderRadius: 20 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }),
)(Switch);

const CustomSwitch: FC<ICustomSwitch> = ({ label, name, initialState, handleSelectColumn }) => {
  const css = useStyles();
  const { t } = useTranslation();

  const [state, setState] = useState({ [name]: initialState });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    handleSelectColumn({ name: event.target.name, selected: event.target.checked });
  };

  return (
    <Grid container className={css.container} alignItems="center">
      <FormControlLabel
        className={css.formControlLabel}
        control={<OysterSwitch checked={state[name]} onChange={handleChange} name={name} />}
        label={<span className={css.label}>{label}</span>}
        labelPlacement="end"
      />
    </Grid>
  );
};

export default CustomSwitch;
